export default "__VITE_ASSET__DNS8HGH4__"